import ApprovalIcon from '@mui/icons-material/Approval';

const OrderStatus = {
  id: '14',
  title: 'Status Mgmt',
  type: 'group',
  role: 'PHARMA_OMS_ADMIN, PHARMA_OMS_MD, PHARMA_OMS_MANAGER',
  children: [
    {
      id: 'approvalmgmt',
      title: 'Order Status',
      type: 'item',
      url: '/',
      bottomMenu: 'APPROVAL_MGMT',
      icon: ApprovalIcon
    }
  ]
};

export default OrderStatus;
